import RequestUtil from "../utils/RequestUtil";
import Requests from "./Requests";

const basePath = "/explore.catalogues.v1/";

const service = {
    getCatalogues(country: string, store: string, foodIndicator: string) {
        const url =
            basePath +
            "country/" +
            encodeURIComponent(country) +
            "?" +
            RequestUtil.buildQuery({
                type: foodIndicator,
                storeid: store
            });
        return Requests.get(url, null, { timeout: 30000, headers: RequestUtil.makeCallTreeHeader() });
    },
    getCataloguesForAllStores(country: string, foodIndicator: string) {
        const url =
            basePath +
            "country/" +
            encodeURIComponent(country) +
            "?" +
            RequestUtil.buildQuery({
                type: foodIndicator
            });
        return Requests.get(url, null, { timeout: 30000, headers: RequestUtil.makeCallTreeHeader() });
    }
};

export default service;
